<template>
    <TopBackgroundComponent/>
    <!-- <ContactTopComponent /> -->
    <ContactForm />
    <ContactMaps />
</template>

<script setup>
    import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    // import ContactTopComponent from '@/components/contact-us/ContactTopComponent.vue';
    import ContactForm from '@/components/contact-us/ContactForm.vue';
    import ContactMaps from '@/components/contact-us/ContactMaps.vue';
    // document.title = 'Contact Us - RS Melinda 3';
    window.scrollTo(0, 0);
</script>